import { createApiClient } from "@medicorepay/shared/lib/api-client";
import { getOrCreateDeviceId } from "@medicorepay/shared/lib/telemetry-sdk";
import {
  clearWebRefreshRecoveryNonce,
  commitWebRefreshedSession,
  getWebAccessToken,
  getWebRefreshRecoveryNonce,
  getWebRefreshToken,
  getWebSessionGeneration,
  invalidateWebAuthSession,
  setWebRefreshRecoveryNonce,
} from "./auth-session";

const RAW_API_URL = import.meta.env.VITE_API_URL || "http://localhost:5001";

export const apiClient = createApiClient({
  rawUrl: RAW_API_URL,
  clientApplication: "web",
  clientVersion: import.meta.env.VITE_APP_VERSION || "1.0.0",
  sourceDevice: getOrCreateDeviceId("web"),
  getAccessToken: getWebAccessToken,
  getRefreshToken: getWebRefreshToken,
  setTokens: (accessToken, refreshToken) => {
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("refreshToken", refreshToken);
  },
  getSessionGeneration: getWebSessionGeneration,
  commitRefreshedSession: commitWebRefreshedSession,
  getRefreshRecoveryNonce: getWebRefreshRecoveryNonce,
  setRefreshRecoveryNonce: setWebRefreshRecoveryNonce,
  clearRefreshRecoveryNonce: clearWebRefreshRecoveryNonce,
  onSessionRefreshed: (response) => {
    window.dispatchEvent(
      new CustomEvent("auth-session-refreshed", { detail: response }),
    );
  },
  onAuthFailure: () => {
    invalidateWebAuthSession();
    localStorage.removeItem("user");
    localStorage.removeItem("permVersion");
    localStorage.removeItem("auth-storage");
    window.location.href = "/login";
  },
  // Permission version callbacks for handling stale permissions
  getPermVersion: () => localStorage.getItem("permVersion"),
  onPermStale: () => {
    // Clear cached permission data when permissions are stale
    localStorage.removeItem("permissions");
    // Show notification and trigger session refresh
    const event = new CustomEvent("perm-stale", {
      detail: { message: "Your permissions have changed. Please refresh." },
    });
    window.dispatchEvent(event);
  },
});

export default apiClient;
